<template>
    <div>


        <div class="content-top">
            <div class="const-a">
                <div class="content-top-left">
                    <img src="../assets/images/ap-1.png" alt="" @click="goToHome">
                </div>

                <div class="content-top-right">

                    <div class="text-a" @click="goToCalculusBC">CalculusBC</div>
                    <div class="text-a" @click="goToMicroeconomics">Microeconomics</div>
                    <div class="text-a" @click="goToMacroeconomics">Macroeconomics</div>
                    <div class="text-a" @click="goToPhysics1">Physics1</div>
                    <div class="text-a" @click="goToBiology">Biology</div>
                    <div class="text-a" @click="goToCSP">CSP</div>
                </div>
            </div>


        </div>



    </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
const router = useRouter()
// const goToHome = () => {
//     router.push('/')
// }
// const goToMicroeconomics = () => {
//     router.push('/microeconomics')
// }
// const goToBiology = () => {
//     router.push('/biology')
// }
// const goToPhysics1 = () => {
//     router.push('/physics1')
// }
// const goToCSP = () => {
//     router.push('/csp')
// }
// const goToMacroeconomics = () => {
//     router.push('/macroeconomics')
// }
// const goToCalculusBC = () => {
//     router.push('/calculusbc')
// }

</script>

<style scoped>
* {

    width: 100vw;

    .content-top {

        width: 1440px;
        height: 100px;
        width: 100vw;

        background-color: black;
        height: 100px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;

        .const-a {
            width: 1200px;
            height: 100px;
            display: flex;
            align-items: center;

            .content-top-left {
                width: 202px;
                height: 44px;
                margin-right: 108px;

                img {
                    width: 202px;
                    height: 44px;
                }
            }


            .content-top-right {
                width: 890px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .text-a {
                    
                    font-family: PingFang SC, PingFang SC;
                    font-weight: bold;
                    font-size: 22px;
                    color: #FFFFFF;
                    margin-right: 39px;
                }
            }
        }
    }

    .content-content {
        background-color: blanchedalmond;
    }


}
</style>